<ng-content></ng-content>
<cm-inspector-section>
    <ng-container cm-title> Position </ng-container>
    <ng-container cm-content>
        @if ($lockedTransform() !== undefined) {
            @if ($targetableNode(); as targetableNode) {
                <cm-value-slot
                    [node]="targetableNode"
                    [key]="'lockedTransform'"
                    [overwrittenValue]="$targetableNodeTransform()"
                    (updatedOverwrittenValue)="onTargetableNodeLockedTransformChanged($event)"
                    [schema]="transformLike"
                ></cm-value-slot>
            } @else {
                <cm-value-slot [node]="$node()" [key]="'lockedTransform'" [label]="'Locked transform'" [schema]="transformLike"> </cm-value-slot>
            }
        } @else {
            Position is computed and cannot be set
        }
    </ng-container>
</cm-inspector-section>
